(() => {
  const breakpoint = window.matchMedia('(min-width: 1101px)');
  const tidyTitles = root => {
    root.querySelectorAll('.tmenu_wrapper .tmenu_item_link[title]').forEach(link => {
      if (link.title.trim() === link.textContent.trim()) {
        if (!link.hasAttribute('aria-label')) link.setAttribute('aria-label', link.title.trim());
        link.removeAttribute('title');
      }
    });
  };
  document.addEventListener('click', event => {
    const tab = event.target.closest('.tmenu_wrapper .tmenu_submenu_tab_control [role="tab"]');
    if (!tab) return;
    event.preventDefault();
    event.stopPropagation();
    const item = tab.parentElement;
    item.dispatchEvent(new MouseEvent('mouseenter', {bubbles:false}));
    item.dispatchEvent(new MouseEvent('mouseover', {bubbles:true}));
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const root = event.target.closest('.tmenu_wrapper .tmenu_item--root');
    const toggle = root?.querySelector(':scope > .tmenu_toggle[aria-expanded="true"]');
    if (toggle) {
      toggle.click();
      root.querySelector(':scope > .tmenu_item_link')?.focus();
      event.preventDefault();
    }
  });
  const boot = () => {
    tidyTitles(document);
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('.tmenu_wrapper, .tmenu_item, .tmenu_submenu') || node.querySelector('.tmenu_item_link'))))) tidyTitles(document);
    }).observe(document.body, {childList:true,subtree:true});
    breakpoint.addEventListener('change', event => {
      document.querySelectorAll('.tmenu_wrapper .tmenu_nav > .tmenu_item_active > .tmenu_toggle[aria-expanded="true"]').forEach(toggle => toggle.click());
      const drawer = document.querySelector('#Details-menu-drawer-container');
      if (event.matches && drawer?.open) drawer.querySelector('summary')?.click();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});
  else boot();
})();
